<template>
  <div class="zoom-info">
    <div><span>级别：{{curLevel}}</span></div>
    <div><span>经度：{{curLng}}</span></div>
    <div><span>纬度：{{curLat}}</span></div>
    <div><span>当前：{{curAreaName}}</span></div>
  </div>
</template>
<script>
  import layerSrc from '../../config/layer_identify'

  export default {
    name: "map-botton-bar",
    created() {

    },
    data() {
      return {
        curLevel: 0,
        curLng: 0,
        curLat: 0,
        curAreaName: "",
        curAreaCode: "",
        zoomIng:false,
        mapName:""
      }
    },
    methods: {
      init(mapName) {
        this.mapName = mapName;
        let map = this.GLOBAL[mapName];
        map.on('zoomend',this.zoomEnd);
        map.on('drag', this.mapDrag);
        map.on('moveend', this.mapMoveEnd);
        this.addQueryAdminLayer();
        setTimeout(() => {
          this.refreshBottomInfo();
        },1000)
      },

      /**
       * drag事件
       */
      mapDrag() {
        let map = this.GLOBAL[this.mapName];
        this.curLng = map.getCenter().lng.toFixed(6);
        this.curLat = map.getCenter().lat.toFixed(6);
      },

      /**
       * mapMoveEnd事件
       */
      mapMoveEnd() {
        this.refreshBottomInfo();
      },

      /**
       * zoomEnd事件
       */
      zoomEnd() {
        if(this.zoomIng){
          return
        }else{
          this.zoomIng = true;
        }
        this.getMapZoomEnd().then(res => {
          this.zoomIng = false;
          this.refreshBottomInfo();
        }).catch(

        );
      },

      /*确定下级图层加载出来之后执行回调*/
      getMapZoomEnd() {
        let map = this.GLOBAL[this.mapName];
        return new Promise((resolve, reject) => {
            let setTime = "";
            let z = map.getZoom();
            let interval = setInterval(() => {
              if (map.isStyleLoaded()) {
                clearInterval(interval);
                clearTimeout(setTime);
                resolve();
              };
            }, 10);
            /*超时没结果不再查询*/
            setTime = setTimeout(() => {
              clearInterval(interval);
              console.log(`bottomBra:资源加载慢,查询当前位置超时`);
              reject();
            },8000);
        });
      },

      /**
       * 属性底部数据
       */
      refreshBottomInfo(){
        let map = this.GLOBAL[this.mapName];
        this.curLevel = map.getZoom().toFixed(2);
        this.curLng = map.getCenter().lng.toFixed(6);
        this.curLat = map.getCenter().lat.toFixed(6);
        this.calCenterAdminArea();
      },

      /**
       * 添加查询需要的layer
       */
      addQueryAdminLayer () {
        let map = this.GLOBAL[this.mapName];
        layerSrc.layer_Drilldown.forEach(item => {
          if (!map.getLayer(item.layerId + "_search") && map.getLayer(item.layerId) ) {
            map.addLayer({
              "id": item.layerId+"_search",
              "type": "fill",
              "source": map.getLayer(item.layerId).source,
              "source-layer": map.getLayer(item.layerId).source,
              "minzoom": map.getLayer(item.layerId).minzoom,
              "maxzoom": map.getLayer(item.layerId).maxzoom,
              "paint": {
                "fill-opacity": 0.0,
              },
            });
          }
        });
      },

      /**
       * 计算地图中心位置所在的行政区划
       */
      calCenterAdminArea() {
        let map = this.GLOBAL[this.mapName];
        let centPt = map.project(map.getCenter());

          let features = map.queryRenderedFeatures(centPt);//查询点击的要素

          let tempLvl = 6;/*一共六个级别*/
          let resLevel = "";
          let res = "";/*最终结果*/
          features.forEach(feature => {/*查找当前遍历元素对应的配置数据*/
            let lyrDrl = layerSrc.layer_Drilldown.find(lyr => {
              return feature.layer.source === lyr.sourceId
            });
            if ( lyrDrl && lyrDrl.level <= tempLvl) {
              resLevel = lyrDrl.level;
              res = feature;
            }
          });

          this.curAreaName = res ? res.properties.qhmc : "";
          this.curAreaCode = res ? res.properties.qhdm : "";
          /*存储当前位置信息*/
          this.GLOBAL.curXzqInfo = {
            curAreaCode:this.curAreaCode,
            curAreaName:this.curAreaName,
            curLevel:resLevel
          }

      },
    }
  }
</script>

<style scoped>
  .zoom-info {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 1;
    font-size: 12px;
    height: 24px;
    text-align: center;
  }

  .zoom-info div {
    width: 180px;
    border-right: 2px solid #fff;
    text-align: center;
    height: 14px;
    margin: 5px 0;
    display: inline-block;
  }

  .zoom-info div:last-child {
    border: none;
  }

  .zoom-info div span {
    color: #fff;
    position: relative;
    top: -3px;
  }

  .zoom-info div span {
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/uiComponents/mapBottonBar.vue